module.exports = __webpack_public_path__ + "static/media/ins.51cdbff6.svg";